
import * as defaultImport from "@splunk/react-icons/CaretSmallRight";
export * from "@splunk/react-icons/CaretSmallRight";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
